import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { VcsIntegration } from "types/generated";

const VCSIntegrationsTableDescriptionCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<VcsIntegration>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={integration.description} />
    </TableSimpleCell>
  );
};

export default VCSIntegrationsTableDescriptionCell;
